import React,{useEffect} from 'react'
import { useSelectorCustom } from '../../general/general-component/abstruct-component/useSelectorCustom';
import { loadProjectTypes } from '../../../store/Actions/ActionProjectType';
import { AbstructVar } from '../../general/general-component/abstruct-component/AbstructVar';
import { loadVisitors } from '../../../store/Actions/ActionVisitor';
import { filterCreativeWork } from '../../../store/Actions/ActionCreativeWork';
import { VariableCreativeWorkRequests } from './VariableCreativeWorkRequests';

function FilterScriptsReqests({ translate }) {
    const { dispatch, navigate,langLocal } = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableCreativeWorkRequests();
    const { projectTypes, visitors } = useSelectorCustom()

    useEffect(() => {
        dispatch(loadProjectTypes())
        dispatch(loadVisitors())
    }, []);
    const Filter = (e) => {
        e.preventDefault()
        dispatch(filterCreativeWork(state.status,state.date_from,state.date_to,state.creative_work_type_id,state.visitor_id,setLoad))
    }
    return (
        <div className='filteruser shadow_main margin_main' dir={langLocal=== 'ar' ? "rtl" : "ltr"}>
            <h3>{translate('search_filter')}</h3>
            <div className='div_filter' >
                <select className={`select_filter  ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} onChange={(e) => setStateCustom('status', e.target.value)}>
                    <option disabled selected >{translate('status')}</option>
                    <option value='accepted' >Accepted</option>
                    <option value='unaccepted' >Un Accepted</option>
                    <option value='reject' >Reject</option>
                </select>
                <input type='date' className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('date_from')} onChange={(e) => setStateCustom('date_from', e.target.value)} />
                <input type='date' className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('date_to')} onChange={(e) => setStateCustom('date_to', e.target.value)} />
                <select  className={`select_filter  ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `}  onChange={(e) => setStateCustom('creative_work_type_id', e.target.value)} >
                    <option disabled selected >{translate('ProjectTypes')}</option>
                    {
                        projectTypes.map((item) => {
                            return (
                                <option value={item.id} >{item.name}</option>
                            )
                        })
                    }
                </select>
                <select  className={`select_filter  ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `}  onChange={(e) => setStateCustom('visitor_id', e.target.value)} >
                    <option disabled selected >{translate('visitors')}</option>
                    {
                        visitors.map((item) => {
                            return (
                                <option value={item.id} >{item.first_name} {item.last_name}</option>
                            )
                        })
                    }
                </select>
                <button className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterScriptsReqests